// Date 2020-07-15 15:45:51

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import emArchBasicDataEdit from "@/views/em/archive/EmArchBasicDataEdit.vue";
import emArchBasicDataList from "@/views/em/archive/EmArchBasicDataList.vue";
import emEquipmentCategoryEdit from "@/views/em/archive/EmEquipmentCategoryEdit";
import emEquipmentCategoryList from "@/views/em/archive/EmEquipmentCategoryList";
import emLocationList from "@/views/em/archive/EmLocationList";
import emLocationEdit from "@/views/em/archive/EmLocationEdit";
import emArchToolList from "@/views/em/archive/EmArchToolList.vue";
import emArchToolEdit from "@/views/em/archive/EmArchToolEdit.vue";
import emArchToolChangeDetailList from "@/views/em/archive/EmArchToolChangeDetailList.vue";
import emArchToolChangeDetailEdit from "@/views/em/archive/EmArchToolChangeDetailEdit.vue";
import emArchToolChangeRecordEdit from "@/views/em/archive/EmArchToolChangeRecordEdit.vue";
import emArchToolChangeRecordList from "@/views/em/archive/EmArchToolChangeRecordList.vue";
import emArchToolChangeTypeList from "@/views/em/archive/EmArchToolChangeTypeList.vue";
import emArchToolChangeTypeEdit from "@/views/em/archive/EmArchToolChangeTypeEdit.vue";
import emArchToolTypeEdit from "@/views/em/archive/EmArchToolTypeEdit.vue";
import emArchToolTypeList from "@/views/em/archive/EmArchToolTypeList.vue";
import emArchToolChangeList from "@/views/em/archive/EmArchToolChangeList.vue";
import emArchToolChangeEdit from "@/views/em/archive/EmArchToolChangeEdit.vue";
import emArchToolChangeTask from "@/views/em/archive/EmArchToolChangeTask.vue";
import emArchScrapProcessAspList from "@/views/em/archive/EmArchScrapProcessAspList";
import emArchScrapProcessAspEdit from "@/views/em/archive/EmArchScrapProcessAspEdit";
import emArchScrapProcessAspTask from "@/views/em/archive/EmArchScrapProcessAspTask";
import emStocktakingTaskList from "@/views/em/archive/EmStocktakingTaskList.vue";
import emStocktakingTaskEdit from "@/views/em/archive/EmStocktakingTaskEdit.vue";
import emStocktakingTaskDetailList from "@/views/em/archive/EmStocktakingTaskDetailList.vue";
import emStocktakingTaskDetailEdit from "@/views/em/archive/EmStocktakingTaskDetailEdit.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
    {
        path: "/em/archive/emArchFault/list",
        name: "emArchFaultList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchFault/edit",
        name: "emArchFaultEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolKit/list",
        name: "emArchToolKitList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolKit/edit",
        name: "emArchToolKitEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    // {
    //     path: "/em/archive/emLocation/list",
    //     name: "emLocationList",
    //     component: emLevelTreeListView,
    //     props: (route) => ({ prop_inline: route.query.inline }),
    //     meta: metaObject
    // },
    // {
    //     path: "/em/archive/emLocation/edit",
    //     name: "emLocationEdit",
    //     component: emEntityEditView,
    //     meta: metaObject
    // },
    // {
    //     path: "/em/archive/emEquipmentCategory/list",
    //     name: "emEquipmentCategoryList",
    //     component: emEntityListView,
    //     props: (route) => ({ prop_inline: route.query.inline }),
    //     meta: metaObject
    // },
    // {
    //     path: "/em/archive/emEquipmentCategory/edit",
    //     name: "emEquipmentCategoryEdit",
    //     component: emEntityEditView,
    //     meta: metaObject
    // },
    {
        path: "/em/archive/emEquipmentLevel/list",
        name: "emEquipmentLevelList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emEquipmentLevel/edit",
        name: "emEquipmentLevelEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emEquipmentStatus/list",
        name: "emEquipmentStatusList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emEquipmentStatus/edit",
        name: "emEquipmentStatusEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchManufacturer/list",
        name: "emArchManufacturerList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchManufacturer/edit",
        name: "emArchManufacturerEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchCostStatistic/list",
        name: "emArchCostStatisticList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchCostStatistic/edit",
        name: "emArchCostStatisticEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchCostStatisticType/list",
        name: "emArchCostStatisticTypeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchCostStatisticType/edit",
        name: "emArchCostStatisticTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchFaultFeatureTag/list",
        name: "emArchFaultFeatureTagList",
        component: emLevelTreeListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchFaultFeatureTag/edit",
        name: "emArchFaultFeatureTagEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchFaultRefTag/list",
        name: "emArchFaultRefTagList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchFaultRefTag/edit",
        name: "emArchFaultRefTagEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchFaultType/list",
        name: "emArchFaultTypeList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchFaultType/edit",
        name: "emArchFaultTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchLaborCostStand/list",
        name: "emArchLaborCostStandList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchLaborCostStand/edit",
        name: "emArchLaborCostStandEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchSppUnloadRecord/list",
        name: "emArchSppUnloadRecordList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchSppUnloadRecord/edit",
        name: "emArchSppUnloadRecordEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolKitDetail/list",
        name: "emArchToolKitDetailList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolKitDetail/edit",
        name: "emArchToolKitDetailEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchSupplier/list",
        name: "emArchSupplierList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchSupplier/edit",
        name: "emArchSupplierEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchBdaREafmBarem/list",
        name: "emArchBdaREafmBaremList",
        component: emEntityListView,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchBdaREafmBarem/edit",
        name: "emArchBdaREafmBaremEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emCapitalSource/list",
        name: "emCapitalSourceList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/archive/emCapitalSource/edit",
        name: "emCapitalSourceEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchBasicDataRelMaterial/list",
        name: "emArchBasicDataRelMaterialList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchBasicDataRelMaterial/edit",
        name: "emArchBasicDataRelMaterialEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchBdaRelSppBrs/list",
        name: "emArchBdaRelSppBrsList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline,
            prop_import: route.query.import,
            prop_export: route.query.export
        }),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchBdaRelSppBrs/edit",
        name: "emArchBdaRelSppBrsEdit",
        component: emEntityEditView,
        meta: metaObject
    },
//自定义页面注册
    {
        path: "/em/archive/emArchBasicDataEdit",
        name: "emArchBasicDataEdit",
        component: emArchBasicDataEdit,
        meta: metaObject
    },
    {
        path: "/em/archive/emArchBasicDataList",
        name: "emArchBasicDataList",
        component: emArchBasicDataList,
        meta: metaObject
    },
    // {
    //     path: "/em/archive/emArchBdaRelSppBrsList",
    //     name: "emArchBdaRelSppBrsList",
    //     component: emArchBdaRelSppBrsList,
    //     props: (route) => ({prop_inline: route.query.inline}),
    //     meta: metaObject
    // },
    // {
    //     path: "/em/archive/emArchBdaRelSppBrsEdit",
    //     name: "emArchBdaRelSppBrsEdit",
    //     component: emArchBdaRelSppBrsEdit,
    //     props: (route) => ({prop_inline: route.query.inline}),
    //     meta: metaObject
    // },
    {
        path: "/em/archive/emEquipmentCategoryEdit",
        name: "emEquipmentCategoryEdit",
        component: emEquipmentCategoryEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emEquipmentCategoryList",
        name: "emEquipmentCategoryList",
        component: emEquipmentCategoryList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emLocationList",
        name: "emLocationList",
        component: emLocationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emLocationEdit",
        name: "emLocationEdit",
        component: emLocationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolList",
        name: "emArchToolList",
        component: emArchToolList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolEdit",
        name: "emArchToolEdit",
        component: emArchToolEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolChangeDetailList",
        name: "emArchToolChangeDetailList",
        component: emArchToolChangeDetailList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolChangeDetailEdit",
        name: "emArchToolChangeDetailEdit",
        component: emArchToolChangeDetailEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolChangeRecordEdit",
        name: "emArchToolChangeRecordEdit",
        component: emArchToolChangeRecordEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolChangeRecordList",
        name: "emArchToolChangeRecordList",
        component: emArchToolChangeRecordList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolChangeTypeList",
        name: "emArchToolChangeTypeList",
        component: emArchToolChangeTypeList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolChangeTypeEdit",
        name: "emArchToolChangeTypeEdit",
        component: emArchToolChangeTypeEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolTypeEdit",
        name: "emArchToolTypeEdit",
        component: emArchToolTypeEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolTypeList",
        name: "emArchToolTypeList",
        component: emArchToolTypeList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolChangeList",
        name: "emArchToolChangeList",
        component: emArchToolChangeList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolChangeEdit",
        name: "emArchToolChangeEdit",
        component: emArchToolChangeEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchToolChangeTask",
        name: "emArchToolChangeTask",
        component: emArchToolChangeTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchScrapProcessAspList",
        name: "emArchScrapProcessAspList",
        component: emArchScrapProcessAspList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchScrapProcessAspEdit",
        name: "emArchScrapProcessAspEdit",
        component: emArchScrapProcessAspEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emArchScrapProcessAspTask",
        name: "emArchScrapProcessAspTask",
        component: emArchScrapProcessAspTask,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/em/archive/emStocktakingTaskList",
        name: "emStocktakingTaskList",
        component: emStocktakingTaskList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/archive/emStocktakingTaskEdit",
        name: "emStocktakingTaskEdit",
        component: emStocktakingTaskEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/archive/emStocktakingTaskDetailList",
        name: "emStocktakingTaskDetailList",
        component: emStocktakingTaskDetailList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/em/archive/emStocktakingTaskDetailEdit",
        name: "emStocktakingTaskDetailEdit",
        component: emStocktakingTaskDetailEdit,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    }

]
